<template>
  <v-textarea ref="field" :data-testid="testid(dataTestid)" :error-messages="errorMessagesComputed" @update:error="hasError = $event" :loading="loading || loadingInternal" :label="label" :disabled="disabled" v-model="editedValue" @keydown="keydown()" @keyup.esc="revertField()" @change="onChange()" v-bind="$attrs" v-on="$listeners">
    <template slot="append-outer" v-if="editedValue != initialValue">
      <div>
        <v-btn :data-testid="dataTestid+'-save-icon'" icon small :color="buttonColor" @click="saveField()" :disabled="hasError">
          <v-icon>done</v-icon>
        </v-btn>
        <v-btn :data-testid="dataTestid+'-revert-icon'" v-if="!hideRevert" icon small :color="buttonColor" @click="revertField()">
          <v-icon>undo</v-icon>
        </v-btn>
      </div>
    </template>
  </v-textarea>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    initialValue: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hideRevert: {
      type: Boolean,
      default: false
    },
    buttonColor: {
      type: String,
      default: "primary"
    },
    errorMessages: {
      type: String | Array,
      default: () => {
        return [];
      }
    },
    dataTestid: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      editedValue: this.initialValue,
      errorMessageInternal: [],
      loadingInternal: false,
      hasError: false,
    }
  },
  computed: {
    errorMessagesComputed() {
      var msgs = [].concat(this.errorMessageInternal);
      if (Array.isArray(this.errorMessages)) {
        msgs = msgs.concat(this.errorMessages);
      }
      else if (typeof this.errorMessages === 'string') {
        msgs.push(this.errorMessages);
      }
      return msgs;
    }
  },
  methods: {
    revertField() {
      this.editedValue = this.initialValue;
      this.errorMessageInternal = [];
      this.$emit('revertField', {
        source: this,
      });
    },
    saveField() {
      if (this.hasError) return;
      this.$emit('saveField', {
        source: this,
        newValue: this.editedValue
      });
    },
    setError(msg) {
      if (msg == null) {
        this.errorMessageInternal = [];
      }
      else {
        this.errorMessageInternal = [msg];
      }
    },
    setLoading(loading) {
      this.loadingInternal = loading;
    },
    keydown(field) {
      this.errorMessageInternal = [];
    },
    focus() {
      this.$refs.field.focus();
    },
    onChange() {
      this.$emit('onChange', {
        source: this,
        newValue: this.editedValue
      });
    },
    testid(dataTestid) {
      if(dataTestid == "messageEdit") {
        return 'discussion-message-edit-textarea';
      }
      else if(dataTestid== "descriptionEdit") {
        return 'survey-description-edit-textarea';
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/ui/InlineEditArea.vue